import { Tag } from '@ontruck/orc';
import cx from 'classnames';
import PropTypes from 'prop-types';

export const SKINS = {
  primary: 'primary',
  white: 'white',
  grey: 'grey',
  accent: 'accent',
  success: 'success',
  error: 'error',
  deepPurple: 'deep-purple',
  lhExpress: 'lh-express',
  userTypeSystem: 'user-type-system',
  userTypeInternal: 'user-type-internal',
  userTypeShipper: 'user-type-shipper',
  userTypeCrossdock: 'user-type-crossdock',
  userTypeCarrier: 'user-type-carrier',
};

const ServiceTag = ({ className, text, skin, size, textTransform, title }) => {
  return (
    <Tag
      className={cx(className, skin)}
      text={text}
      size={size}
      textTransform={textTransform}
      weight="bold"
      title={title}
    />
  );
};

ServiceTag.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
  size: PropTypes.string,
  textTransform: PropTypes.string,
  weight: PropTypes.string,
};

export default ServiceTag;
